import React from "react";

import { Box } from "@mui/material";

interface TabContentProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabContent: React.FC<TabContentProps> = ({
  children,
  value,
  index,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value != index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

export default TabContent;
